export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4640.9e1eaa34.jpg";